/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeUpdateDocumentApprovalCommand, type ProblemDetails, type UpdateDocumentApprovalCommand } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /documents/{id}/approval
 */
export interface ApprovalRequestBuilder extends BaseRequestBuilder<ApprovalRequestBuilder> {
    /**
     * UpdateDocumentApproval
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: UpdateDocumentApprovalCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * UpdateDocumentApproval
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateDocumentApprovalCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ApprovalRequestBuilderUriTemplate = "{+baseurl}/documents/{id}/approval";
/**
 * Metadata for all the requests in the request builder.
 */
export const ApprovalRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ApprovalRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateDocumentApprovalCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
